<template>
	<div class="set-password">
		<el-card shadow="never">
			<span slot="header" class="row" align-y="center" gutter="5">
				<b>成立小組</b>
				<div class="center bg-black-gray1 color-white" style="border-radius:100%;width:20px;height:20px;">{{num}}</div>
			</span>
			<el-form label-position="left" label-width="100px" :model="ruleForm" :rules="rules" ref="setUpPasswordForm">
				<el-form-item label="小組名稱">
					<span>{{story.team_name}}</span>
				</el-form-item>
				<el-form-item label="你的故事帳號">
					<span>{{story.account}}</span>
				</el-form-item>
				<el-form-item label="組別密碼" prop="password">
					<el-input placeholder="請輸入密碼" v-model="ruleForm.password"></el-input>
				</el-form-item>
				<el-form-item>
					<div class="col color-text3" gutter="5">
						<span>*密碼請至少設定 6 個字元，日後可修改</span>
						<span>小組成立後，可邀請小組成員使用故事帳號（帳號）及密碼直接登入編輯故事</span>
					</div>
				</el-form-item>
				<el-form-item class="row" align-x="right">
					<div class="button-tp color-white bg-green1 save-button" @click="save">儲存</div>
				</el-form-item>
			</el-form>
		</el-card>
	</div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";

export default {
	props: ["num", "story"],
	data() {
		return {
			ruleForm: {
				password: ""
			},
			rules: {
				password: [
					{
						required: true,
						message: "請輸入密碼（至少6字元）",
						trigger: "blur"
					},
					{ min: 6, message: "長度至少為6字元", trigger: "blur" }
				]
			}
		};
	},
	computed: {},
	methods: {
		...mapMutations("story", ["updatePasswordStoryPassword"]),
		...mapActions("story", ["updateStory"]),
		initStory() {
			this.ruleForm.password = this.story.password;
		},
		save() {
			this.$refs["setUpPasswordForm"].validate(async valid => {
				if (valid) {
					let data = {
						id: this.story.id,
						password: this.ruleForm.password
					};

					try {
						await this.updateStory(data);
						this.updatePasswordStoryPassword(data);
						this.$message.success("設定成功");
					} catch (e) {
						this.$message.error(e);
					}
				}
			});
		}
	},
	created() {
		this.initStory();
	},
	mounted() { },
	components: {}
};
</script>

<style lang="scss" scoped>
.save-button {
	width: 150px;
	height: 30px;
}
</style>